import GenericResponse from "../objects/GenericResponse";
import UrlHelper from "../utils/UrlHelper";

type LogoutCallback = () => void;
let globalLogout: LogoutCallback | null = null;

export const setGlobalLogout = (cb: LogoutCallback) => {
  globalLogout = cb;
};

export default class FetchService {
  private getHeaders(): Record<string, string> {
    const headers: Record<string, string> = {
      "Content-type": "application/json; charset=UTF-8",
    };
    const token = localStorage.getItem('token');
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    return headers;
  }

  private async request(
    method: "GET" | "POST" | "DELETE" | "PUT",
    uri: string,
    body?: object,
    id?: string
  ): Promise<GenericResponse> {
    try {
      const response = await fetch(UrlHelper.fullApiUrl(uri, id), {
        method,
        body: body ? JSON.stringify(body) : undefined,
        headers: this.getHeaders(),
      });

      const text = await response.text();
      let obj: any = {};
      try {
        obj = text ? JSON.parse(text) : {};
      } catch {
        obj = { message: text };
      }

      if (!response.ok) {
        if (response.status === 401) {
          globalLogout?.();
        }

        const errorMsg =
          obj.message ||
          obj.Message ||
          obj.Status ||
          (Array.isArray(obj) && obj[0]?.description) ||
          response.statusText ||
          "Request failed";
        return new GenericResponse(obj, errorMsg);
      }

      return new GenericResponse(obj);
    } catch (error: any) {
      return new GenericResponse(null, error.message || String(error));
    }
  }

  public get = (uri: string, id?: string): Promise<GenericResponse> => {
    return this.request("GET", uri, undefined, id);
  };

  public post = (
    uri: string,
    body?: object,
    id?: string
  ): Promise<GenericResponse> => {
    return this.request("POST", uri, body, id);
  };

  public put = (
    uri: string,
    body?: object,
    id?: string
  ): Promise<GenericResponse> => {
    return this.request("PUT", uri, body, id);
  };

  public delete = (uri: string, id?: string): Promise<GenericResponse> => {
    return this.request("DELETE", uri, undefined, id);
  };

  public uploadFile = async (
    uri: string,
    file: File,
    id?: string
  ): Promise<GenericResponse> => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const headers: Record<string, string> = {};
      const token = localStorage.getItem("token");
      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      }

      const response = await fetch(UrlHelper.fullApiUrl(uri, id), {
        method: "POST",
        body: formData,
        headers,
      });

      const text = await response.text();
      let obj: any = {};
      try {
        obj = text ? JSON.parse(text) : {};
      } catch {
        obj = { message: text };
      }

      if (!response.ok) {
        if (response.status === 401) {
          globalLogout?.();
        }
        const errorMsg =
          obj.message ||
          obj.Message ||
          obj.Status ||
          (Array.isArray(obj) && obj[0]?.description) ||
          response.statusText ||
          "Upload failed";
        return new GenericResponse(obj, errorMsg);
      }

      return new GenericResponse(obj);
    } catch (error: any) {
      return new GenericResponse(null, error.message || String(error));
    }
  };
}
